import axios, { AxiosRequestConfig } from "axios";
import AppStore from "../AppStore";
import RequestService from "./RequestService";

// Options for configuring requests
export type HttpOptions = {
   url: string;
   data?: any;
   onUploadProgress?: (percentage: number) => void;
   useFormData?: boolean;
   waitMessage?: string;
};

axios.interceptors.response.use(undefined, (err) => {
   var errorInfo = err.response.data;
   AppStore.toast.show({
      severity: "error",
      summary: errorInfo.detail ?? "An error has occured.",
      detail: errorInfo.detail ?? "An error has occured.",
      life: 3000,
   });

   return Promise.reject(err);
});

class Http {
   constructor() {
      axios.defaults.baseURL = "api/";
      axios.defaults.headers.get["Pragma"] = "no-cache";
      axios.defaults.headers.get["Cache-Control"] = "no-cache, no-store";
   }

   async get<T>(options: HttpOptions): Promise<T> {
      const requestId = RequestService.addRequest(
         options.url,
         options.waitMessage || ""
      );

      const response = await axios
         .get(options.url, { params: options.data })
         .finally(() => {
            RequestService.removeRequest(requestId);
         });

      if (response === undefined) return response;
      return response.data as T;
   }

   async put<T>(options: HttpOptions): Promise<T> {
      const requestId = RequestService.addRequest(
         options.url,
         options.waitMessage || ""
      );

      const response = await axios
         .put(options.url, options.data)
         .finally(() => {
            RequestService.removeRequest(requestId);
         });

      return response.data as T;
   }

   async post<T>(options: HttpOptions): Promise<T> {
      const config: AxiosRequestConfig = {};
      const response = await axios.post(options.url, options.data, config);
      return response.data as T;
   }

   async delete<T>(options: HttpOptions): Promise<T> {
      const requestId = RequestService.addRequest(
         options.url,
         options.waitMessage || ""
      );

      const response = await axios
         .delete(options.url, { params: options.data })
         .finally(() => {
            RequestService.removeRequest(requestId);
         });

      return response.data as T;
   }
}

export default new Http();
